import { render, staticRenderFns } from "./ContributorBanner.vue?vue&type=template&id=7473ee36"
import script from "./ContributorBanner.vue?vue&type=script&lang=js"
export * from "./ContributorBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports